import React, { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

function WYSIWYGEditor({ onChange, value }: any) {
  const [content, setContent] = useState("");
  const quillRef: any = useRef(null);

  const handleChange = (value: string, delta: any, source: string, editor: any) => {
    if (source === "user") {
      setContent(value);
    }
  };

  useEffect(() => {
    if (content) onChange(content);

    const quill = quillRef.current?.getEditor();
    const cursorPosition = quill.getSelection()?.index || content.length; 


    setTimeout(() => {
      quill.setSelection(cursorPosition); 
    }, 0);

  }, [content]);

  useEffect(() => {
    if (value !== undefined) {
      setContent(value);
    }
  }, [value]);

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["bold", "italic", "underline", "strike"],
      [{ align: [] }],
      [{ color: [] }, { background: [] }],
      ["link", "image"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "font",
    "list",
    "bullet",
    "bold",
    "italic",
    "underline",
    "strike",
    "align",
    "color",
    "background",
    "link",
    "image",
  ];

  return (
    <div>
      <ReactQuill
        value={content}
        onChange={handleChange}
        ref={quillRef}
        modules={modules}
        formats={formats}
        placeholder="Votre besoin"
      />
    </div>
  );
}

export default WYSIWYGEditor;
